import React from "react";
import "./Transcript.css";

interface TranscriptProps {
  messages: { text: string; speaker: string; dateTime: string }[];
}

const Transcript: React.FC<TranscriptProps> = ({ messages }) => {
  return (
    <section className="transcript-container">
      {messages.map((message, index) => (
        <div
          key={index}
          className={`chat-details chat ${
            message.speaker === "INTERNAL" ? `chat-end` : `chat-start`
          }`}
        >
          <div className="chat-header">{message.speaker === "INTERNAL" ? "Agent" : "Caller"}</div>
          <div className="chat-bubble">{message.text}</div>
          <div className="chat-footer opacity-50">{new Date(message.dateTime).toLocaleString("en-US")}</div>
          {/* <div className="chat-footer opacity-50">{message.dateTime}</div> */}
        </div>
      ))}
    </section>
  );
};

export default Transcript;
